import { Cart, OrderDispatchOption, Product, ProductCategory } from "~/types";
import { useBaseMenu } from "./menu-v2";
import { useCart } from "./cart";
import { HOT_DEALS_CATEGORY_ID_PREFIX } from "~/constants";

export function useDeal(
  locationRef: string,
  fulfillmentType: OrderDispatchOption | null,
  plu: string | null,
) {
  const { cart } = useCart();
  const { menu, isLoading } = useBaseMenu(locationRef, fulfillmentType, null);

  const deal = findDeal(menu, cart, plu);

  return {
    isLoading,
    ...deal,
  };
}

export function findDeal(
  menu: ProductCategory[],
  cart: Cart,
  plu: string | null,
): { product: Product; cartItemLineItemId?: string } | null {
  const deals =
    menu.find((c) => c.id.startsWith(HOT_DEALS_CATEGORY_ID_PREFIX))?.products ||
    [];

  const product = deals.find(
    (product) =>
      product.plu && plu && product.plu.toLowerCase() === plu.toLowerCase(),
  );

  if (!product) return null;

  const cartItem = cart.items.find((item) => item.productId === product?.id);

  return {
    product: product,
    cartItemLineItemId: cartItem?.lineItemId,
  };
}
